/**
 * Header desktop - Ticket 12932738728 "Revoir le header"
 *
 * Le picto loupe ouvre la recherche live existante sous forme de barre pleine
 * largeur en haut de page. LiveSearch (empire.js) n'ouvre son mode "takeover"
 * que sous le breakpoint S, d'où ce toggle dédié au desktop.
 * Délégation d'événements sur document : survit aux rechargements de section
 * dans l'éditeur de thème.
 */
(function () {
  if (window.__headerDesktopSearchInit) return;
  window.__headerDesktopSearchInit = true;

  var OPEN_CLASS = 'is-desktop-open';
  var BODY_CLASS = 'desktop-search-open';

  function getSearch() {
    return document.querySelector('[data-site-header] [data-live-search]');
  }

  function getToggle() {
    return document.querySelector('[data-desktop-search-toggle]');
  }

  function isOpen() {
    var search = getSearch();
    return !!search && search.classList.contains(OPEN_CLASS);
  }

  /* La bannière d'annonce (app Yeps) se place au-dessus du body, qu'elle décale
     via margin-top, avec un z-index supérieur : la barre se cale sous sa partie visible. */
  function placeSearch() {
    var search = getSearch();
    if (!search) return;
    var top = Math.max(0, document.body.getBoundingClientRect().top);
    search.style.setProperty('--desktop-search-top', top + 'px');
  }

  function onScroll() {
    if (isOpen()) placeSearch();
  }

  function open() {
    var search = getSearch();
    if (!search) return;

    placeSearch();
    window.addEventListener('scroll', onScroll, { passive: true });
    search.classList.add(OPEN_CLASS);
    document.body.classList.add(BODY_CLASS);

    var toggle = getToggle();
    if (toggle) toggle.setAttribute('aria-expanded', 'true');

    var input = search.querySelector('[data-live-search-input]');
    if (input) {
      window.requestAnimationFrame(function () {
        input.focus();
      });
    }
  }

  function close(restoreFocus) {
    var search = getSearch();
    if (!search) return;

    var input = search.querySelector('[data-live-search-input]');
    if (input) input.blur();

    search.classList.remove(OPEN_CLASS);
    document.body.classList.remove(BODY_CLASS);
    window.removeEventListener('scroll', onScroll);

    var toggle = getToggle();
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus) toggle.focus();
    }
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-desktop-search-toggle]')) {
      event.preventDefault();
      if (isOpen()) {
        close(true);
      } else {
        open();
      }
      return;
    }

    if (!isOpen()) return;

    if (event.target.closest('[data-live-search-takeover-cancel]')) {
      close(true);
      return;
    }

    if (!event.target.closest('[data-live-search]')) {
      close(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) {
      close(true);
    }
  });

  document.addEventListener('shopify:section:load', function () {
    document.body.classList.remove(BODY_CLASS);
    observeHeaderHeight();
  });

  /* Hauteur réelle du header (réduite au scroll) exposée en variable CSS :
     la barre de filtres collante s'aligne dessus au lieu de valeurs fixes. */
  var headerObserver = null;

  function setHeaderHeight(header) {
    document.documentElement.style.setProperty('--site-header-height', header.offsetHeight + 'px');
  }

  function observeHeaderHeight() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;

    setHeaderHeight(header);
    if (!('ResizeObserver' in window)) return;

    if (headerObserver) headerObserver.disconnect();
    headerObserver = new ResizeObserver(function () {
      setHeaderHeight(header);
    });
    headerObserver.observe(header);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeHeaderHeight);
  } else {
    observeHeaderHeight();
  }
})();
